import { ChevronDown } from '@atom-learning/icons'
import { Trigger } from '@radix-ui/react-collapsible'
import React from 'react'

import { ActionIcon } from '~/components/action-icon/ActionIcon'
import { Icon } from '~/components/icon/Icon'
import { styled } from '~/styled'
import { cn } from '~/styled'

import { TreeCollapsibleContext } from './TreeCollapsible'
import { TreeItemContent } from './TreeItemContent'

const StyledActionIcon = styled(ActionIcon, {
  base: [
    'absolute',
    'left-0',
    'top-0',
    'pointer-events-none',
    '[&_svg]:duration-300',
    '[&_svg]:transition-transform',
    '[&[data-state=closed]>svg]:-rotate-90',
    '[&[data-state=open]>svg]:rotate-0'
  ]
})

type TNavigationMenuCollapsibleTriggerProps = React.ComponentProps<
  typeof TreeItemContent
> & {
  label: string
}

export const TreeCollapsibleTrigger = ({
  children,
  label,
  className,
  ...rest
}: TNavigationMenuCollapsibleTriggerProps) => {
  const { setTriggerRef, triggerRef } = React.useContext(TreeCollapsibleContext)

  return (
    <TreeItemContent
      {...rest}
      className={cn('cursor-pointer', className)}
      onClick={(event) => {
        rest.onClick?.(event)
        triggerRef?.current?.click()
      }}
    >
      <Trigger asChild>
        <StyledActionIcon
          size="sm"
          ref={setTriggerRef}
          label={label}
          theme="neutral"
          hasTooltip={false}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon is={ChevronDown} />
        </StyledActionIcon>
      </Trigger>
      {children}
    </TreeItemContent>
  )
}
